import React from 'react'
import IlustrationImage from './illustration-dashboard.png'

import './ilustration.css'

export default function Ilustration() {
    return (
        <div className="ilustration-container">
            <img src={IlustrationImage} alt=""/>
        </div>
    )
}